module.exports = __webpack_public_path__ + "static/circledark-3376098c2c392089affd4a43a5738e27.svg";